<template>
	<div class="">
		<div class="fenbuBox2">
			<div class="fenbu2" id="fenbu"></div>
		</div>
	</div>
</template>

<script>
// import echarts from 'echarts'
	export default {
		name: "",
		components: {

		},
    props:{
      majorData:{type:Object,default:null}
    },
		data() {
			return {
			}
		},
    watch:{
      majorData(vl){
        if(vl.hangye!=null){
          this.tupiao()
        }
      }
    },
		mounted(){
			this.tupiao()
		},
		methods: {
			tupiao(){
        let _this = this;
				var myChart = this.$echarts.init(document.getElementById('fenbu'));
        let scaleData = []
        if(this.majorData.area){
          this.majorData.area.forEach(function(item,index){
            scaleData.push({name:item,value:_this.majorData.arearate[index]})
          })
        }

        console.log(scaleData)
					// var  scaleData = [
					// 	{name: '浙江',value: 20},{name: '其他',value: 8},{name: '山东',value: 13},{name: '河南',value: 13},
					//     {name: '北京',value: 12},{name: '河北', value: 17},{name: '内蒙', value: 16},{name: '辽宁',value: 20},
					// ];
					var rich = {
					    white: {
					        color: '#fff',
					        align: 'center',
					        padding: [1, 0]
					    }
					};
					var placeHolderStyle = {
					    5: {
					        label: {
					            show: false
					        },
					        labelLine: {
					            show: false
					        },
					        color: 'rgba(0, 0, 0, 0)',
					        borderColor: 'rgba(0, 0, 0, 0)',
					        borderWidth: 0
					    }
					};
					var data = [];
					var color1 = ['#3087D6', '#1FE15F', '#FAD73A', '#FCEBD0','#F87D7C','#A52F09','#00D9D9','#9B8BFF','#9B8BFF'];

					for (var i = 0; i < scaleData.length; i++) {
					    data.push({
					        value: scaleData[i].value,
					        name: scaleData[i].name,
					        itemStyle: {
					            normal: {
					                borderWidth: 0,
					                borderColor:color1[i],
					                shadowColor: color1[i],
					                color: color1[i],
					                opacity:1,
					            }
					        }
					    }, );
					}
					var seriesObj = [{
					    name: '',
					    type: 'pie',
					    clockWise: false,
						center: ['50%', '50%'],
						 radius:['20%','100%'],

					    hoverAnimation: false,
					    itemStyle: {
					        normal: {
					            label: {
					                show: true,
					                position: 'inner',
					                fontWeight:'bold',
									color: '#fff',
					                formatter: function(params) {
					                    var percent = 0;
					                    var total = 0;
					                    for (var i = 0; i < scaleData.length; i++) {
					                        total += scaleData[i].value;
					                    }
					                    percent = ((params.value / total) * 100).toFixed(0);
					                    if(params.name !== '') {
					                        return params.name + '\n{white|' + '' + percent + '%}';
					                    }else {
					                        return '';
					                    }
					                },
					                rich: rich
					            },
					            labelLine: {
					                show: false,
					            }
					        }
					    },
					    data: data
					}];
					var option = {
					    tooltip: {
					        show: false
					    },
					    legend: {
					        show: false
					    },
					    toolbox: {
					        show: false
					    },
					    series: seriesObj
					}

				// 使用刚指定的配置项和数据显示图表。
					myChart.setOption(option);
			}
		}


	}
</script>

<style scoped>
	.fenbuBox2{
		width: 100%;
		height: 500px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.fenbu2{width: 600px;height: 300px;}
</style>



// WEBPACK FOOTER //
// src/views/tubiao/kaoyanyujiuye_biao.vue